import React from 'react';

const SectionHeader = ( { title, color }) => (
  <div className='panel-subsection-title-container' style={{marginBottom: 10}}>
    <div className='panel-subsection-title'>{title}</div>
  </div>
)

export default SectionHeader
